import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@material-ui/core";
import { Box } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { GetLicenseName } from "../../../../../api/PE_API";
import Configurations from "../../../../../config";
import useStyles from "../../../../../css/styles_PE";
import { ApptContext } from "../../../../../store";
import { Buffer } from "buffer";
import { InsertPPLogs } from "../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Appointment confirmation page after booking

export default function Confirmation() {
  const styles = useStyles();
  const { state } = useContext(ApptContext);
  let apptType = "1";
  if (state.AppointmentType === "telederm") {
    apptType = "2";
  }

  let patientName = "";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName =
      JSON.parse(data).PatientFirstName +
      " " +
      JSON.parse(data).PatientLastName;
    userName = JSON.parse(data).Login;
  }

  const dateOptions: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  };

  const navigate = useNavigate();
  const handleNextClick = async () => {
    InsertPPLogs(
      "Clicked on Next - Confirmation Page",
      window.location.href,
      userName,
      ""
    );
    const appt_n = state.Appointment_N;
    var encodedAppt_n = Buffer.from(appt_n.toString()).toString("base64");
    let licensename = await GetLicenseName();
    licensename = licensename[0].replace(" ", "+");
    navigate(
      "/user/bookappointment/features/" +
        encodedAppt_n +
        "/" +
        licensename +
        "/0"
    );
  };
  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box
      ref={scrollTo}
      sx={{
        width: "100%",
        padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
      }}
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant={window.innerWidth < 768 ? "subtitle1" : "h5"}
            style={{ color: "limegreen" }}
          >
            Your Appointment has been Booked!
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item xs={11}>
          <Typography
            variant="h6"
            style={{
              display: state.AppointmentType === "inoffice" ? "flex" : "none",
            }}
          >
            <p>
              {"Hi " + patientName + ","}
              <br />
              {"Your appointment has been booked with"}{" "}
              <b>
                {" "}
                {state.SlotDetails.employeeName +
                  " on " +
                  state.SlotDetails.slotDate.toLocaleString(
                    "en-US",
                    dateOptions
                  ) +
                  " at " +
                  state.SlotDetails.facilityName}
              </b>
            </p>
          </Typography>
          <Typography
            variant="h6"
            style={{
              display: state.AppointmentType === "telederm" ? "flex" : "none",
            }}
          >
            <p>
              {"Hi " + patientName + ","}
              <br />
              {"Your appointment has been booked with"}{" "}
              <b>
                {" "}
                {state.SlotDetails.employeeName +
                  " on " +
                  state.SlotDetails.slotDate.toLocaleString(
                    "en-US",
                    dateOptions
                  )}
              </b>
            </p>
          </Typography>
        </Grid>
        <Grid item xs={9} spacing={1}>
          <Typography style={{ fontSize: "1.05rem" }}>
            To speed up your appointment, Please click on the Next button to
            fill out the Health Forms and upload any Supporting Documents
          </Typography>
        </Grid>
        <Grid item xs={2} spacing={1}>
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleNextClick}
            style={{ marginLeft: 10 }}
          >
            Next
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={5}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "1%",
          }}
        >
          <Card
            style={{
              display: "flex",
              flexDirection: "column",
              width: "400px",
            }}
          >
            <CardHeader
              classes={{
                subheader: styles.selectedSlot_subheader,
              }}
              style={{
                backgroundColor: "#2FABBF",
                color: "white",
              }}
              title="Appointment Time:"
              subheader={
                state.SlotDetails.slotDate.toLocaleDateString() +
                " at " +
                state.SlotDetails.slotDate.toLocaleString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }
            />
            <CardContent>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                {state.SlotDetails.employeeName}
              </Typography>
              <Typography
                variant="body1"
                style={{
                  display:
                    state.AppointmentType === "telederm" ? "none" : "flex",
                }}
              >
                {state.Facility.Name === null ||
                state.Facility.Name === undefined
                  ? ""
                  : state.Facility.Name + ", "}
                <br />
                {state.Facility.Address === null ||
                state.Facility.Address === undefined
                  ? ""
                  : state.Facility.Address}
                <br />
                {state.Facility.Phone === null ||
                state.Facility.Phone === undefined
                  ? ""
                  : state.Facility.Phone}
              </Typography>
              <hr />
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                {state.AppointmentType === "telederm"
                  ? Configurations.digitalApptType + " Appointment"
                  : "In-office Appointment"}
              </Typography>
              <Typography variant="body2">
                {state.AppointmentType === "inoffice"
                  ? "For your protection, we adhere to all CDC guidelines. All patients are required to wear a mask and follow proper social distancing. If your insurance requires a referral, please have it with you."
                  : "You will receive an email with a link to join a TeleHealth Appointment. Please use the link to join a meeting 5 minutes prior to your appointment time. For a better video visit experience, we recommend that you connect to Wi-Fi/high-speed internet connection and limit your data usage. For privacy purposes, you should be in a private place during your visit and should use headphones or a headset to avoid having someone overhearing your conversation."}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
